function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".aaa{fill:#f9eec0 !important;opacity:1 !important}"));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "aaa",
  d: "M36,14.982l-2.052,1.065-1.705-.655.372-7.148L26.236,0,22.6,1.974l-3.01.343L18.668,3.79l-1.2-1.463L12.058,1.305,8.858,3.4,3.27,10.432,0,12.177l4.773,4.459L3.9,18.8l3.388,2.062,2.091-1.424.5.434L8,21.875l3.268,3.1L23.488,26.3l3.947-3.343,6.693,2.71-.207-4,2.357-3.1,1.58-.479.191-2.56Zm1.132,2.52-1.315.4-2.675,3.525.159,3.08-6.01-2.433L23.245,25.5,11.607,24.246l-2.532-2.4,1.9-2.028-1.54-1.34L7.261,19.953,4.848,18.484l.831-2.047L1.3,12.348l2.4-1.281L9.327,4l2.891-1.889,4.833.913,1.7,2.068,1.293-2.059,2.719-.31L26.031.981l5.811,7.506-.386,7.42L34,16.883l2.1-1.087,1.146.3Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "aaa",
  d: "M27.843,14.96H26.107L25.7,12.331a.337.337,0,0,0-.326-.285.376.376,0,0,0-.337.271l-.963,4.8L23,9.644a.338.338,0,0,0-.668,0L20.9,18.783,19.4,7.518a.338.338,0,0,0-.67,0L17.24,18.783,15.8,9.639a.338.338,0,0,0-.668,0l-1.072,7.474-.963-4.8a.385.385,0,0,0-.343-.27.337.337,0,0,0-.322.285l-.4,2.629H10.293a.225.225,0,0,0-.225.224v.224a.225.225,0,0,0,.225.224h2.024a.337.337,0,0,0,.333-.285l.161-1.034.975,4.859a.337.337,0,0,0,.664-.018l1.031-7.192,1.45,9.327a.314.314,0,0,0,.326.284h.01a.34.34,0,0,0,.332-.292l1.465-11.062L20.531,21.28a.338.338,0,0,0,.669.008l1.45-9.326,1.031,7.192a.337.337,0,0,0,.325.289.362.362,0,0,0,.34-.271l.975-4.859.161,1.034a.334.334,0,0,0,.333.285h2.029a.225.225,0,0,0,.225-.224v-.224a.225.225,0,0,0-.225-.224Z"
});

var SvgLogoCutremurSimbol = function SvgLogoCutremurSimbol(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 38.05,
    height: 26.296,
    viewBox: "0 0 38.05 26.296",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoCutremurSimbol, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Logo_Cutremur_Simbol.d45edee1.svg";
export { ForwardRef as ReactComponent };